import { render, staticRenderFns } from "./form-wrapper.vue?vue&type=template&id=d23c57aa&scoped=true&"
import script from "./form-wrapper.vue?vue&type=script&lang=js&"
export * from "./form-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./form-wrapper.vue?vue&type=style&index=0&id=d23c57aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23c57aa",
  null
  
)

component.options.__file = "form-wrapper.vue"
export default component.exports